import axiosInstance from "../../../helpers/axiosInstance";
import {
  VERSION_PUBLICADA_ERROR,
  VERSION_PUBLICADA_LOADING,
  VERSION_PUBLICADA_RESET,
  VERSION_PUBLICADA_SUCCESS,
} from "../../ActionTypes";
import axiosLogin from "../../../helpers/axiosLogin";
export const wsGetVersionPublicadaAndroid = () => (dispatch) => {
  dispatch({
    type: VERSION_PUBLICADA_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get("/versionPublicada/appAndroid")
      .then((res) => {
        dispatch({
          type: VERSION_PUBLICADA_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: VERSION_PUBLICADA_ERROR,

          payload: error,
        });
      });
  });
};

export const wsGetVersionPublicadaIos = () => (dispatch) => {
  dispatch({
    type: VERSION_PUBLICADA_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get("/versionPublicada/appIOS")
      .then((res) => {
        dispatch({
          type: VERSION_PUBLICADA_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: VERSION_PUBLICADA_ERROR,

          payload: error,
        });
      });
  });
};

/* export const wsGetVersionPublicadaPortalWeb = (version) => (dispatch) => {
  dispatch({
    type: VERSION_PUBLICADA_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/versionPublicada/portalWeb/${version}`)
      .then((res) => {
        dispatch({
          type: VERSION_PUBLICADA_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: VERSION_PUBLICADA_ERROR,

          payload: error,
        });
      });
  });
}; */
export const wsGetVersionPublicadaPortalWeb = (version) => (dispatch) => {
  dispatch({
    type: VERSION_PUBLICADA_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/shared/info/version/${version}`)
      .then((res) => {
        dispatch({
          type: VERSION_PUBLICADA_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: VERSION_PUBLICADA_ERROR,

          payload: error,
        });
      });
  });
};

export const resetVersionPortal = () => (dispatch) => {
  dispatch({ type: VERSION_PUBLICADA_RESET });
};
